module.exports = __webpack_public_path__ + "img/syukyaku-co-001.eef89eab.png";